<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Bitiş Tarihi</label>
            <v-date-picker v-model="value.ValidityEndDate" placeholder="Başlangıç Tarihi"></v-date-picker>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>

<style>

</style>